"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useOnOutsideClick_1 = require("../../Hooks/useOnOutsideClick");
const Typography_1 = __importStar(require("../UI/Typography"));
const Types_1 = require("Types");
const style = __importStar(require("./styled"));
const user_1 = require("../../Endpoints/user");
const useUserData_1 = __importDefault(require("../../Hooks/useUserData"));
const user_2 = require("../../Redux/Actions/user");
const react_redux_1 = require("react-redux");
const useInitialData_1 = __importDefault(require("../../Hooks/useInitialData"));
const useTranslate_1 = require("../../Hooks/useTranslate");
const useCommercePermissions_1 = __importDefault(require("../../Hooks/useCommercePermissions"));
const useHeaderData_1 = __importDefault(require("../../Hooks/useHeaderData"));
const react_router_1 = require("react-router");
const Utils_1 = require("../../Utils");
const request_1 = require("../../Endpoints/request");
const Constants_1 = require("@/Constants");
const Skeleton_1 = __importDefault(require("../UI/Skeleton/Skeleton"));
const MyHaldexDropdown = ({ setIsLoginOpen, setIsMyHaldexOpen }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const userData = (0, useUserData_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const wrapperRef = (0, react_1.useRef)(null);
    const initialData = (0, useInitialData_1.default)();
    const { t, isReady } = (0, useTranslate_1.useTranslate)();
    const headerData = (0, useHeaderData_1.default)();
    const history = (0, react_router_1.useHistory)();
    const { canSeeInvoices, canSeeOrders } = (0, useCommercePermissions_1.default)();
    const registerFormLink = (_a = initialData === null || initialData === void 0 ? void 0 : initialData.pages) === null || _a === void 0 ? void 0 : _a.registrationPage;
    const isNorthAmerica = (0, react_redux_1.useSelector)((state) => state.initialData.isNorthAmerica);
    const canSeeCoreLinks = (_b = userData === null || userData === void 0 ? void 0 : userData.roles) === null || _b === void 0 ? void 0 : _b.some(role => role === Types_1.UserRoles.NA_CORE_REPORTS);
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, () => setIsMyHaldexOpen(false));
    const handleLogin = () => {
        setIsMyHaldexOpen(false);
        setIsLoginOpen(true);
    };
    const handleLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield (0, user_1.logoutUser)();
        if (result === request_1.ResponseTypes.OK) {
            history.push(headerData.LogoUrl);
            dispatch((0, user_2.fetchUserData)());
            (0, Utils_1.deleteCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED);
            localStorage.removeItem(Constants_1.LocalStorage.EXPIRATION_IN_MINUTES);
            localStorage.removeItem(Constants_1.LocalStorage.EXPIRATION_TIME);
            setIsMyHaldexOpen(false);
        }
    });
    if (!isReady)
        return (react_1.default.createElement(style.DropdownContainer, { ref: wrapperRef },
            react_1.default.createElement(style.WhiteArrow, null),
            react_1.default.createElement(style.LoaderContainer, null,
                react_1.default.createElement(Skeleton_1.default, null))));
    return (react_1.default.createElement(style.DropdownContainer, { ref: wrapperRef },
        react_1.default.createElement(style.WhiteArrow, null),
        !(userData === null || userData === void 0 ? void 0 : userData.isAuthenticated) && (react_1.default.createElement(react_1.default.Fragment, null, isNorthAmerica ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(style.ListButton, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: handleLogin },
                react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_1 }, t('/haldex/header/sign_in'))),
            registerFormLink && (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1 },
                react_1.default.createElement(style.Link, { href: registerFormLink, onClick: () => setIsMyHaldexOpen(false) }, t('/haldex/header/register')))))) : (react_1.default.createElement(style.SignInButton, { onClick: handleLogin }, t('/haldex/header/sign_in'))))),
        (0, Utils_1.myHaldexVisibility)(userData, isNorthAmerica) && (react_1.default.createElement(react_1.default.Fragment, null,
            ((_c = initialData.pages) === null || _c === void 0 ? void 0 : _c.myHaldexPage) && (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1, first: true },
                react_1.default.createElement(style.Link, { href: initialData.pages.myHaldexPage }, t('/haldex/header/my_haldex')))),
            ((_d = initialData.pages) === null || _d === void 0 ? void 0 : _d.myOrdersPage) && canSeeOrders && (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1 },
                react_1.default.createElement(style.Link, { href: initialData.pages.myOrdersPage }, t('/haldex/header/my_orders')))),
            ((_e = initialData.pages) === null || _e === void 0 ? void 0 : _e.myInvoicesPage) && canSeeInvoices && (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1 },
                react_1.default.createElement(style.Link, { href: initialData.pages.myInvoicesPage }, t('/haldex/header/my_invoices')))),
            ((_f = initialData.pages) === null || _f === void 0 ? void 0 : _f.myCoreAnalysisPage) && canSeeCoreLinks && (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1 },
                react_1.default.createElement(style.Link, { href: initialData.pages.myCoreAnalysisPage }, t('/haldex/header/my_core_analysis')))),
            ((_g = initialData.pages) === null || _g === void 0 ? void 0 : _g.myCoreReportsPage) && canSeeCoreLinks && (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1 },
                react_1.default.createElement(style.Link, { href: initialData.pages.myCoreReportsPage }, t('/haldex/header/my_core_reports')))),
            initialData.userDropDownLinks &&
                initialData.userDropDownLinks.map((link, i) => (react_1.default.createElement(style.TypographyLink, { type: Typography_1.Types.BODY_1, key: i },
                    react_1.default.createElement(style.Link, { href: link.href }, link.title || link.text)))))),
        (userData === null || userData === void 0 ? void 0 : userData.isAuthenticated) && (react_1.default.createElement(style.ListButton, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: handleLogout },
            react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_1 }, t('/haldex/header/logout'))))));
};
exports.default = MyHaldexDropdown;
